import {Component, inject, Input} from '@angular/core';
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {LotteryLicenceService} from "../../../services/lottery-licence.service";
import {IGameLotteryLicence} from "../../../interfaces/IGameLotteryLicence";
import {MatError} from "@angular/material/form-field";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {LotteryLicenseReportComponent} from "../lottery-license-report/lottery-license-report.component";
import {ErrorHandlingService} from "../../../services/error-handling.service";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {NgIf} from "@angular/common";
import {ILotteryLicenseReportingData} from "../../../interfaces/reporting/ILotteryLicenseReportingData";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {UIStateEnum} from "../../../enum/UIStateEnum";

@Component({
  selector: 'app-lottery-license-reporting',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    MatButton,
    LotteryLicenseReportComponent,
    NgIf,
    MatError,
    MatDatepickerModule,
    MatProgressSpinner
  ],
  templateUrl: './lottery-license-reporting.component.html',
  styleUrl: './lottery-license-reporting.component.css'
})
export class LotteryLicenseReportingComponent {
  @Input() set gameSetter(gameP: IGameQueryResult) {
    this.activeGame = gameP;
    this.uiState = UIStateEnum.ShowLoading;
    // if the user is already looking at the reports for one game, and they change the game, then we want to just fetch the new data
    // for the new game
    this.lotteryLicenceService.fetchLotteryLicences(gameP.Id).subscribe({
      next: result => {
        this.lotteryLicenses = result;
        this.uiState = UIStateEnum.ShowData;
      },
      error: error => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage("Failed to fetch lottery licences for the chosen game");
      }
    });

    if(this.showReports) {
      this.onSubmit();
    }
  }

  public lotteryLicenseFormGroup = new FormGroup({
    lotteryLicense: new FormControl<IGameLotteryLicence | null>(null, Validators.required),
    startDate: new FormControl<string>("", Validators.required),
    endDate: new FormControl<string>("", Validators.required)
  });

  public reportingData!: ILotteryLicenseReportingData;
  public showReports = false;
  public activeGame: IGameQueryResult | null = null;
  public lotteryLicenses: IGameLotteryLicence[] = [];
  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateEnumForTemplate = UIStateEnum;

  private lotteryLicenceService = inject(LotteryLicenceService);
  private errorHandlingService = inject(ErrorHandlingService);

  onSubmit() {
    if (!this.lotteryLicenseFormGroup.valid) {
      this.lotteryLicenseFormGroup.markAllAsTouched();
      return;
    }

    this.reportingData = {
      LotteryLicenseId: this.lotteryLicenseFormGroup.controls.lotteryLicense.value?.Id!,
      StartDate: this.lotteryLicenseFormGroup.controls.startDate.value!,
      EndDate: this.lotteryLicenseFormGroup.controls.endDate.value!,
      GameId: this.activeGame?.Id!
    };

    this.showReports = true;
  }
}
